module.exports = __webpack_public_path__ + "static/media/login.a136352.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/views/aigc/assets/login.mp4
// module id = nGkK
// module chunks = 130